module.exports = __webpack_public_path__ + "website/img/testi2.aa69fb3c.png";